export const CONTACT_STATUS = {
  ACTIVE: 'A',
  INACTIVE: 'I',
} as const;

export type CONTACT_STATUS =
  (typeof CONTACT_STATUS)[keyof typeof CONTACT_STATUS];

export const CONTACT_STATUS_LABEL: Record<CONTACT_STATUS, string> = {
  [CONTACT_STATUS.ACTIVE]: 'Ativo',
  [CONTACT_STATUS.INACTIVE]: 'Inativo',
} as const;

export const CONTACT_DOCUMENT_TYPE = {
  CPF: 'F',
  CNPJ: 'J',
} as const;

export type CONTACT_DOCUMENT_TYPE =
  (typeof CONTACT_DOCUMENT_TYPE)[keyof typeof CONTACT_DOCUMENT_TYPE];

export const CONTACT_DOCUMENT_TYPE_LABEL: Record<
  CONTACT_DOCUMENT_TYPE,
  string
> = {
  [CONTACT_DOCUMENT_TYPE.CPF]: 'CPF',
  [CONTACT_DOCUMENT_TYPE.CNPJ]: 'CNPJ',
} as const;
